
(function userDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminUserService', [
            'restUrlBuilder', 'config', function adminUserService(restUrlBuilder, config) {
                restUrlBuilder = restUrlBuilder('auth');

                this.getById = function getById(id, forEdit) {
                    if (angular.isUndefined(forEdit)) {
                        forEdit = true;
                    }

                    return restUrlBuilder.one('adminUsers', id)
                        .get({
                            params: {
                                applicationId: config.appId(),
                                forEdit: forEdit
                            }
                        });
                };

                this.getByMail = function getByMail(mail) {
                    var params = {
                        Mail: mail
                    };

                    return restUrlBuilder.all('logins')
                        .get({ params: params });
                };

                this.getWithParams = function get(params) {
                    return restUrlBuilder.all('adminUsers')
                        .get({ params: params });
                };

                this.getRedirectOptions = function getRedirectOptions() {
                    return restUrlBuilder.all('adminUsers/RedirectOptions')
                        .get();
                };

                this.setRedirectOptionBatch = function setRedirectOptionBatch(params) {
                    return restUrlBuilder.all('adminUsers/RedirectOptionBatch')
                        .put(params);
                };

                this.get = function get(nickName, name, lastName, userEnabled, userLocked, organizationalUnitId, completeName, identifier, page, itemsPerPage) {

                    var params = {
                        NickName: nickName,
                        FirstName: name,
                        LastName: lastName,
                        Enabled: userEnabled,
                        Locked: userLocked,
                        OrganizationalUnitId: organizationalUnitId,
                        FullName: completeName,
                        Identifier: identifier,
                        Page: page,
                        ItemPerPage: itemsPerPage
                    };

                    return restUrlBuilder.all('adminUsers')
                        .get({ params: params });
                };

                this.getByRoleId = function getByRoleId(organizationalUnitId, roleId) {

                    var params = { OrganizationalUnitId: organizationalUnitId, RoleId: roleId };

                    return restUrlBuilder.all('adminUsers')
                        .get({ params: params });

                };

                this.getUserImpersonation = function get(id) {

                    var params = { Id: id };

                    return restUrlBuilder.all('UserImpersonation')
                        .get({ params: params });

                };

                this.createUserImpersonation = function (user) {
                    if (user == null)
                        throw "user no puede ser null";

                    return restUrlBuilder.all('UserImpersonation')
                        .post(user);
                };

                this.create = function userCreate(user) {
                    if (user == null)
                        throw "user no puede ser null";

                    user.Url = config.appUrl('/Home/Index#/pwd-first-time/?code={0}');
                    user.applicationId = config.appId();

                    return restUrlBuilder.all('adminUsers')
                        .post(user);
                };

                this.createFromLdap = function userCreateFromAd(user) {
                    if (user == null)
                        throw "user no puede ser null";

                    user.applicationId = config.appId();

                    return restUrlBuilder.all('adminUsers/CreateUserFromLdap')
                        .post(user);
                };

                this.modify = function userModify(user, profile) {
                    if (user == null)
                        throw "user no puede ser null";

                    user.Url = config.appUrl('');
                    user.applicationId = config.appId();

                    return restUrlBuilder.all('adminUsers')
                        .put(user, { params: { profile: profile || false } });
                };

                this.reset = function userReset(user) {
                    if (user == null)
                        throw "user no puede ser null";

                    user.Url = config.appUrl('/Home/Index#/pwd-reset/?code={0}');
                    return restUrlBuilder.all('adminUsers/reset').put(user, {
                        params: {
                            applicationId: config.appId()
                        }
                    });
                };

                this.resetBatch = function userResetBatch(users) {
                    if (users == null)
                        throw "users no puede ser null";

                    users.Url = config.appUrl('/Home/Index#/pwd-reset/?code={0}');
                    users.ApplicationId = config.appId();

                    return restUrlBuilder.all('adminUsers/resetBatch').put(users);
                };
                this.export = function (nickName, name, lastName, userEnabled, userLocked, organizationalUnitId, completeName, identifier, page, itemsPerPage, roleId, applicationId) {
                    var params = { NickName: nickName, FirstName: name, LastName: lastName, Enabled: userEnabled, Locked: userLocked, OrganizationalUnitId: organizationalUnitId, FullName: completeName, Identifier: identifier, Page: page, ItemPerPage: itemsPerPage, RoleId: roleId, ApplicationId: applicationId };

                    return restUrlBuilder.all('adminUsers/Export').put(params);
                };

                this.unlock = function userunLock(user) {
                    if (user == null)
                        throw "user no puede ser null";

                    user.Url = config.appUrl('/Home/Index#/pwd-reset/?code={0}');

                    return restUrlBuilder.all('adminUsers/Unlock').put(user);
                };

                this.exportToXLS = function (filters, headers, sheetName) {
                    var params = {
                        filters: filters,
                        headers: headers,
                        sheetName: sheetName
                    };

                    return restUrlBuilder.all('adminUsers/exportxls').put(params);
                };
            }
        ]);

})();